import { defineStore } from 'pinia';
import { GET_REGISTRY_INFO } from '~/types/actions';
import {
  SET_REGISTRY_INFO,
  SET_BARCODE,
  SET_GIFT_GIVER_VIEW_LOADING,
  SET_GIFT_GIVER_VIEW_ERROR,
  SET_GIFT_GIVER_API_ERROR_RESPONSE,
} from '~/types/mutations';
import { httpGetNonProtectedAPIHeaders } from '~/utils/APIUtil';
import $http from '@vue-util/http';
import { useEnvPropsStore } from '~/stores/envProps';

const GIFT_GIVER_REGISTRY_ENDPOINT = '/regsvc/registry/api/v1/preference/getPreference';

export const useGiftGiverRegistryView = defineStore('giftGiverRegistryView', {
  state: () => ({
    registryInfo: {},
    registryBarCode: '',
    giftGiverViewLoading: true,
    giftGiverApiErrorResponse: null,
    error: false,
  }),
  actions: {
    [SET_REGISTRY_INFO](registryInfo) {
      this.registryInfo = registryInfo;
    },
    [SET_BARCODE](registryBarCode) {
      this.registryBarCode = registryBarCode;
    },
    [SET_GIFT_GIVER_VIEW_LOADING](giftGiverViewLoading) {
      this.giftGiverViewLoading = giftGiverViewLoading;
    },
    [SET_GIFT_GIVER_VIEW_ERROR](error) {
      this.error = error;
    },
    [SET_GIFT_GIVER_API_ERROR_RESPONSE](error) {
      this.giftGiverApiErrorResponse = error;
    },
    async [GET_REGISTRY_INFO](params) {
      const envPropsStore = useEnvPropsStore();

      this[SET_GIFT_GIVER_VIEW_LOADING](true);
      const httpSource = $http.CancelToken.source();
      const timer = setTimeout(() => {
        this[SET_REGISTRY_INFO]({});
        this[SET_GIFT_GIVER_VIEW_ERROR](true);
        this[SET_GIFT_GIVER_VIEW_LOADING](false);
        httpSource.cancel();
      }, envPropsStore.envProps?.apiTimeout || 0);
      try {
        const response = await $http.get(
          `${GIFT_GIVER_REGISTRY_ENDPOINT}?orgId=${params.orgId}&${params.registryGUID ? `registryGUID=${params.registryGUID}` : `registryId=${params.registryId}`}&productInfoFlag=true`,
          {
            headers: httpGetNonProtectedAPIHeaders(),
            cancelToken: httpSource.token,
          },
        );
        clearTimeout(timer);

        const isError = response?.data?.errors || response?.data?.error;
        if (isError) {
          this[SET_REGISTRY_INFO]({});
          this[SET_GIFT_GIVER_VIEW_ERROR](true);
          this[SET_GIFT_GIVER_API_ERROR_RESPONSE](isError);
        } else {
          this[SET_REGISTRY_INFO](response.data?.registryInfo);
          this[SET_BARCODE](response.data?.registryInfo.barCodeNumber);
          this[SET_GIFT_GIVER_VIEW_ERROR](false);
        }
      } catch (error) {
        clearTimeout(timer);
        this[SET_REGISTRY_INFO]({});
        this[SET_GIFT_GIVER_VIEW_ERROR](true);
        this[SET_GIFT_GIVER_API_ERROR_RESPONSE](error?.data?.errors || error?.data?.error);
      } finally {
        this[SET_GIFT_GIVER_VIEW_LOADING](false);
      }
    },
  },
});
